import { useEffect, useState } from "react";

const MAX_SIZE_XS = 576;

const useIsXS = () => {
  const getIsXS = () =>
    typeof window !== "undefined" && window.innerWidth < MAX_SIZE_XS;

  const [isXS, setIsXS] = useState(getIsXS());

  useEffect(() => {
    const handleResize = () => {
      setIsXS(getIsXS());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isXS;
};

export default useIsXS;
